/**
 * Statsig Analytics Event Names
 * Centralized constants for analytics events used across the application
 */
export const ANALYTICS_EVENTS = {
  // Organization Owner Events
  ORG_OWNER_ADD_DIALOG_OPENED: 'org_owner_add_dialog_opened',
  ORG_OWNER_ADDED: 'org_owner_added',
  ORG_OWNER_REMOVE_DIALOG_OPENED: 'org_owner_remove_dialog_opened',
  ORG_OWNER_REMOVED: 'org_owner_removed',

  // Dashboard Filter Events
  DASHBOARD_WORKSPACE_FILTER_CHANGED: 'dashboard_workspace_filter_changed',
  DASHBOARD_AUTOMATION_FILTER_CHANGED: 'dashboard_automation_filter_changed',
  DASHBOARD_TIME_RANGE_CHANGED: 'dashboard_time_range_changed',
  DASHBOARD_CUSTOM_DATE_RANGE_CHANGED: 'dashboard_custom_date_range_changed',

  // Page View Events
  PERFORMANCE_PAGE_VIEWED: 'performance_page_viewed',
  CONSUMPTION_PAGE_VIEWED: 'consumption_page_viewed',

  // Performance Page Events
  PERFORMANCE_DOWNLOAD_REPORT_CLICKED: 'performance_download_report_clicked',
  PERFORMANCE_MOCK_MODE_TOGGLED: 'performance_mock_mode_toggled',
  PERFORMANCE_CONFIGURE_ESTIMATES_CLICKED:
    'performance_configure_estimates_clicked',
  PERFORMANCE_ESTIMATES_SAVED: 'performance_estimates_saved',
  PERFORMANCE_ESTIMATES_DIALOG_CANCELLED:
    'performance_estimates_dialog_cancelled',
  PERFORMANCE_METRIC_SELECTED: 'performance_metric_selected',
  PERFORMANCE_SET_GOAL_CLICKED: 'performance_set_goal_clicked',
  PERFORMANCE_GOAL_SAVED: 'performance_goal_saved',
  PERFORMANCE_GOAL_DIALOG_CANCELLED: 'performance_goal_dialog_cancelled',
  PERFORMANCE_VALUE_INSIGHTS_VIEW_CHANGED:
    'performance_value_insights_view_changed',
  PERFORMANCE_USAGE_VIEW_CHANGED: 'performance_usage_view_changed',

  // Consumption Page Events
  CONSUMPTION_VIEW_CHANGED: 'consumption_view_changed',
  CONSUMPTION_METRIC_SELECTED: 'consumption_metric_selected',

  // Drafts Events
  DRAFTS_GET_STARTED_TEMPLATE_CLICKED: 'drafts_get_started_template_clicked',

  // Remote Connections Events
  REMOTE_CONNECTIONS_PAGE_VIEWED: 'remote_connections_page_viewed',
  REMOTE_CONNECTIONS_CREATE_CLICKED: 'remote_connections_create_clicked',
  REMOTE_CONNECTIONS_CREATED: 'remote_connections_created',
  REMOTE_CONNECTIONS_CREATE_FAILED: 'remote_connections_create_failed',
  REMOTE_CONNECTIONS_DETAIL_VIEWED: 'remote_connections_detail_viewed',
  REMOTE_CONNECTIONS_EDIT_CLICKED: 'remote_connections_edit_clicked',
  REMOTE_CONNECTIONS_UPDATED: 'remote_connections_updated',
  REMOTE_CONNECTIONS_UPDATE_FAILED: 'remote_connections_update_failed',
  REMOTE_CONNECTIONS_DELETE_DIALOG_OPENED:
    'remote_connections_delete_dialog_opened',
  REMOTE_CONNECTIONS_DELETED: 'remote_connections_deleted',
  REMOTE_CONNECTIONS_DELETE_FAILED: 'remote_connections_delete_failed',
  REMOTE_CONNECTIONS_RESTART_DIALOG_OPENED:
    'remote_connections_restart_dialog_opened',
  REMOTE_CONNECTIONS_RESTARTED: 'remote_connections_restarted',
  REMOTE_CONNECTIONS_RESTART_FAILED: 'remote_connections_restart_failed',
  REMOTE_CONNECTIONS_ASSOCIATED_CONNECTION_REMOVED:
    'remote_connections_associated_connection_removed',

  // Notification Center Events
  NOTIFICATION_CENTER_OPENED: 'notification_center_opened',
  NOTIFICATION_CENTER_CLOSED: 'notification_center_closed',
  NOTIFICATION_TAB_SWITCHED: 'notification_tab_switched',
  NOTIFICATION_CLICKED: 'notification_clicked',
  NOTIFICATION_MARK_ALL_READ_CLICKED: 'notification_mark_all_read_clicked',
  NOTIFICATION_MANAGE_SETTINGS_CLICKED: 'notification_manage_settings_clicked',

  // 404 Events
  NOT_FOUND_PAGE_VIEWED: 'not_found_page_viewed',

  // Notification Preferences Events
  NOTIFICATION_MODE_CHANGED: 'notification_mode_changed',
  NOTIFICATION_CHANNEL_SELECTED: 'notification_channel_selected',
  NOTIFICATION_CHANNEL_TOGGLED: 'notification_channel_toggled',
  NOTIFICATION_TYPE_TOGGLED: 'notification_type_toggled',

  // Workbench Queue Events
  WORKBENCH_TIME_RANGE_CHANGED: 'workbench_time_range_changed',
  WORKBENCH_GROUP_TOGGLED: 'workbench_group_toggled',
  WORKBENCH_GROUPS_TOGGLED_ALL: 'workbench_groups_toggled_all',
} as const;

export type AnalyticsEvent =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];
